// API helpers

export type DefectiveChipDetails = {
  unique_id: string;
  defective_on: string;
  defective_reason: string;
};

export enum ActivateRangeErrorCodes {
  ID_NOT_FOUND = 'ID_NOT_FOUND',
  INVALID_ORDER = 'INVALID_ORDER',
  RANGE_TOO_LARGE = 'RANGE_TOO_LARGE',
  RANGE_OVERLAPS_ACTIVATED = 'RANGE_OVERLAPS_ACTIVATED',
}

export type PipelineModel = {
  name: string;
  description: string;
  created_at: string;
};

// Activate manufactured chip range

export type ActivateRangeParams = {
  start_unique_id_first: string;
  start_unique_id_second: string;
  end_unique_id_first: string;
  end_unique_id_second: string;
  lot_number: string;
  test_type: string;
  expiry_date: string;
  model_id: string;
  defective: Array<DefectiveChipDetails>;
};

export type ActivateRangeResponse = {
  count_updated: number;
  lot_number: string;
  test_type: string;
  expiry_date: string;
  model_id: string;
  count_defective: number;
};

// Get pipeline models

export type GetPipelineModelsResponse = Array<PipelineModel>;

// Get test types

export type GetTestTypesResponse = Array<string>;
